import React from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { FaLock,FaHeadset,FaPhoneSquare,FaClock  } from "react-icons/fa";
import './setting.css'
import ChangePassword from './ChangePassword'
import Help from './Help';
import Contact from './Contact';
import ContactTimings from './ContactTimings';
import IgnoreIPs from './IgnoreIPs';
const Setting = () => {
  return (
    <Tab.Container defaultActiveKey="second">
      <h2 className='cmn_heading'>Setting</h2>
      <div className='d-flex col-form-label-sm settingTabs gap-3 align-items-start'>
        <Nav variant="pills" className="flex-column">
        
          <Nav.Item>
            <Nav.Link eventKey="second"><FaLock /> Change Password</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="help"><FaHeadset/> Help</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="contact"><FaPhoneSquare  /> Contact Us</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="contact-timings"><FaPhoneSquare  /> Contact Timings</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="ip-ignore"><FaClock   /> Ignore IP's</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className='flex-grow-1'>
      
          <Tab.Pane eventKey="second">
            <ChangePassword/>
          </Tab.Pane>
          <Tab.Pane eventKey="help">
            <Help/>
          </Tab.Pane>
          <Tab.Pane eventKey="contact">
         <Contact/>
          </Tab.Pane>
          <Tab.Pane eventKey="contact-timings">
         <ContactTimings/>
          </Tab.Pane>
          <Tab.Pane eventKey="ip-ignore">
            <IgnoreIPs/>
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>

  );
}

export default Setting;